export interface SegmentData {
  Key: { StringValue: string }[];
  Data: {
    Impressions: number;
    Clicks: number;
    CTR: number;
    Spend: number;
    TopImpressionRate: number;
    AbsoluteTopImpressionRate: number;
    ConversionsCredit: number;
    PartialConversionRate: number;
    PartialConversionCPA: number;
    AdvertiserReportedRevenue: number;
    RevenueOnAdSpend: number;
    AverageCPC: number;
  };
}

interface MappedSegmentData {
  deviceType: string;
  Impressions: number;
  Clicks: number;
  CTR: number;
  Spend: number;
  TopImpressionRate: number;
  AbsoluteTopImpressionRate: number;
  ConversionsCredit: number;
  PartialConversionRate: number;
  PartialConversionCPA: number;
  AdvertiserReportedRevenue: number;
  RevenueOnAdSpend: number;
  AverageCPC: number;
}

export const mapSegmentData = (segmentedData: SegmentData[]): MappedSegmentData[] =>
  segmentedData.map((segment) => {
    const deviceType = segment.Key[0].StringValue;
    const {
      Impressions,
      Clicks,
      CTR,
      Spend,
      TopImpressionRate,
      AbsoluteTopImpressionRate,
      ConversionsCredit,
      PartialConversionRate,
      PartialConversionCPA,
      AdvertiserReportedRevenue,
      RevenueOnAdSpend,
      AverageCPC,
    } = segment.Data;
    return {
      deviceType,
      Impressions,
      Clicks,
      CTR,
      Spend,
      TopImpressionRate,
      AbsoluteTopImpressionRate,
      ConversionsCredit,
      PartialConversionRate,
      PartialConversionCPA,
      AdvertiserReportedRevenue,
      RevenueOnAdSpend,
      AverageCPC,
    };
  });
